export const NOT_APPLICABLE = "NOT_APPLICABLE";
export const UPCOMING = "UPCOMING";
export const COMPLETED = "COMPLETED";
export const OVERDUE = "OVERDUE";
